module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Paul Adam\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("PAUL ADAM grew up in the north of England and studied law at Nottingham University. He began his writing career as a journalist and has worked in Rome as well as England. He is the author of "), _c('I', [_vm._v("The Rainaldi Quartet. ")]), _vm._v("He lives in Sheffield, England, with his wife and two children.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/16Vs1WL/tc-custom/9781429983655.jpg?1726483181437",
      "alt": "This image is the cover for the book Paganini's Ghost, Castiglione and Guastafeste"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Paganini's Ghost, Castiglione and Guastafeste\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Paganini – showman, womanizer, dazzling virtuoso – is one of the most charismatic characters in the history of classical music. His violin, "), _c('i', [_vm._v("il Cannone")]), _vm._v(" (the Cannon), is now kept in Genoa, Italy, where it is played only once every two years in a sold-out concert by the winner of an international competition."), _c('br'), _c('br'), _vm._v("This year, though, a Parisian art dealer is found dead in his hotel room the day after the concert. In his wallet is a scrap of sheet music, torn from a page that belongs to the competition's winner. But how did the dead man get hold of it? And why?"), _c('br'), _c('br'), _vm._v("Detective Antonio Guastafeste asks violin maker Gianni Castiglione to help him navigate the curious world of classical musicians, their priceless instruments, and the unsavory dealers who prey upon them. Together, Antonio and Gianni must unravel another mystery that has gone unanswered for over a century, one that may hold the answer to the modern-day murder. "), _c('br'), _c('br'), _vm._v("Filled with remarkable history and musical lore, "), _c('i', [_vm._v("Paganini's Ghost")]), _vm._v(" plays at a breathtaking tempo that will keep you reading until the very last page.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Minotaur Books\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0